module.exports = __webpack_public_path__ + "static/media/arrow-left-full.66ba1703.svg";